import { Container, Row, Col, Nav } from 'react-bootstrap';
import { MyWorkflow } from '../../components';
import { Link, useLocation } from 'react-router-dom';

const Workflow = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <Container fluid className="tasks-page">
            <Row>
                <Col>
                    <h1 className="display-1">Workflow</h1>
                    <div className="display-2">Manage Your Workflow</div>
                </Col>
                <Col>
                    <div className="text-end">
                        <Nav className="c-nav-tabs">
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks"
                                    active={currentPath === '/tasks'}
                                >
                                    Tasks
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks/timesheet"
                                    active={currentPath === '/tasks/timesheet'}
                                >
                                    Quick Logs
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks/all-timesheets"
                                    active={currentPath === '/tasks/all-timesheets'}
                                >
                                    All Timesheets
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks/tasklist"
                                    active={currentPath === '/tasks/tasklist'}
                                >
                                    Tasklist
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    as={Link}
                                    to="/tasks/workflow"
                                    active={currentPath === '/tasks/workflow'}
                                >
                                    Workflow
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </Col>
            </Row>
            <Row className="mt-0 gy-4">
                <Col lg={12}>
                    <MyWorkflow />
                </Col>
            </Row>
        </Container>
    );
};

export default Workflow;